import googleTagCart from './google-tag-cart';
import pageLoaded from './page-loaded';
import productAdded from './product-added';
import productViewed from './product-viewed';
import newsletterSubscribed from './newsletter-subscribed';

export default {
  googleTagCart,
  pageLoaded,
  productAdded,
  productViewed,
  newsletterSubscribed
};
